@if(component) {
<div class="flex flex-column-s flex-justify-center wrap m-t-12 m-t-8-s pos-relative"
     [class.flex-middle]="component?.columns[0]?.variant === 'quote' || component?.columns[1]?.variant === 'quote'">
    @for (column of component?.columns; track column) {
    <div class="c-4 c-5-m c-12-s m-a-0-s m-r-3">
        @switch (column.variant) {
        @default {
        <div [routerLink]="column.url"
             [class.cursor-pointer]="column.url != ''">
            <div class="overflow-hidden"
                 [ngClass]="column.ratio">
                <local-shell />
                <img class="rf"
                     [image]="column.image"
                     alt="image"
                     *iCms="'image' of column">
            </div>
            <p class="c1 p-t-2 col-13"
               [ngClass]="column.caption_align"
               *iCms="'caption' of column"></p>
        </div>
        }
        @case ('quote') {
        <div class="center p-a-4-x p-a-4-l p-a-2-m p-t-12-s m-t-2-s p-b-12-s">
            <div [ngClass]="column.quote_font_style"
                 *iCms="'quote' of column">
            </div>
            <p class="p1 p-t-2 col-13"
               *iCms="'caption' of column"></p>
        </div>
        }
        }
    </div>
    }
</div>

}